module.exports = "<symbol id=\"tt-icon-close\" viewBox=\"0 0 24 24\"><path d=\"M23.44 2.86L14.3 12l9.14 9.14-2.3 2.3L12 14.3l-9.14 9.14-2.3-2.3L9.7 12 .56 2.86l2.3-2.3L12 9.7 21.14.56z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/KmHgiPlfcrGbDfYsite/assets/svg/pdp-page/close.svg
// module id = 198
// module chunks = 9